import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const severityBadge = {
    info: 'rh-badge--neutral',
    warning: 'rh-badge--warning',
    critical: 'rh-badge--danger',
};
/**
 * "Co hori" — deterministicky seznam problemu s akci (Kokpit alerts, REOS
 * Attention, Fakturace upominky). AI-ready: polozky muze plnit heuristika
 * i AI, komponenta na AI nezavisi.
 */
export function AttentionList({ items, ariaLabel, severityLabels, emptyState, className, }) {
    if (items.length === 0 && emptyState !== undefined) {
        return _jsx("div", { className: className, children: emptyState });
    }
    return (_jsx("ul", { "aria-label": ariaLabel, className: `rh-attention${className ? ` ${className}` : ''}`, children: items.map((item) => (_jsxs("li", { className: "rh-attention__item", children: [_jsx("span", { className: `rh-badge ${severityBadge[item.severity]}`, children: severityLabels[item.severity] }), _jsxs("div", { className: "rh-attention__body", children: [_jsx("p", { className: "rh-attention__title", children: item.title }), item.detail ? _jsx("p", { className: "rh-attention__detail", children: item.detail }) : null] }), item.action ? (_jsx("button", { type: "button", className: "rh-btn rh-attention__action", onClick: item.action.onAction, children: item.action.label })) : null] }, item.id))) }));
}
//# sourceMappingURL=attention-list.js.map